// extracted by mini-css-extract-plugin
export default {"processingDirectionError":"Failed_processingDirectionError","ErrorCircleSVG":"Failed_ErrorCircleSVG"};